import React from "react";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import parse from "html-react-parser";

import { answerFormat } from "./answer-format";
import { ImgWrapper } from "./ImgWrapper";

const StyledList = styled.ol`
  list-style: none;
  counter-reset: my-awesome-counter;
  & li {
    counter-increment: my-awesome-counter;
  }
  & li::before {
    content: counter(my-awesome-counter) ". ";
    color: red;
    font-weight: bold;
  }
`;

const QuizShowModal = ({ show, setShow, quiz, questions, studentView }) => {
  const questionView = () => {
    return (
      questions &&
      questions.map((question) => {
        const plainQuestionObj = !studentView
          ? question && question.question
          : question;

        return (
          <li>
            <p>{parse(plainQuestionObj && plainQuestionObj.value)}</p>
            {plainQuestionObj && plainQuestionObj.image && (
              <ImgWrapper>
                <img
                  src={plainQuestionObj.image}
                  style={{ width: "100%", maxWidth: "100%" }}
                  alt="question info pic"
                />
              </ImgWrapper>
            )}
            {answerFormat(plainQuestionObj)}
          </li>
        );
      })
    );
  };

const metaDataQuestionView = () => {
  return (
    questions &&
    questions.map((question, index) => {
      const plainQuestionObj = !studentView
        ? question?.question
        : question;

      if (!plainQuestionObj) return null;

      const {
        id,
        mills_difficulty_level,
        standard_code,
        content_source,
        text, // Assuming the question text is under "text"
      } = plainQuestionObj;

      return (
        <li key={index} style={{ display: 'flex', marginBottom: '4rem', marginTop: '2rem' }}>
          <div style={{ marginLeft: '4rem' }}>
            <table style={{ fontFamily: 'inherit' }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      paddingRight: '4rem',
                      paddingBottom: '1rem',
                      fontSize: '1rem',
                      fontFamily: 'inherit',
                    }}
                  >
                    ID Number:&nbsp;
                    <span style={{ fontWeight: 'bolder' }}>{id || ''}</span>
                  </td>
                  <td
                    style={{
                      paddingRight: '4rem',
                      paddingBottom: '1rem',
                      fontSize: '1rem',
                      fontFamily: 'inherit',
                    }}
                  >
                    Difficulty Level:&nbsp;
                    <span style={{ fontWeight: 'bolder' }}>{mills_difficulty_level || ''}</span>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      paddingRight: '4rem',
                      fontSize: '1rem',
                      fontFamily: 'inherit',
                    }}
                  >
                    Standard Code:&nbsp;
                    <span style={{ fontWeight: 'bolder' }}>{standard_code || ''}</span>
                  </td>
                  <td
                    style={{
                      paddingRight: '4rem',
                      fontSize: '1rem',
                      fontFamily: 'inherit',
                    }}
                  >
                    Content Source:&nbsp;
                    <span style={{ fontWeight: 'bolder' }}>{content_source || ''}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
      );
    })
  );
};

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          {quiz && quiz.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <StyledList>{questionView()}</StyledList>
        <hr style={{height:"3px",border:"none",color:"#333",backgroundColor:"#333"}}/>
        <StyledList>{metaDataQuestionView()}</StyledList>
      </Modal.Body>
    </Modal>
  );
};

export default QuizShowModal;
